import React, { Component } from 'react';
import VideoWrapper from './Viewer/VideoWrapper'
import WhiteboardWrapper from './Viewer/WhiteboardWrapper'
// import Overlay from './Viewer/Overlay'
import TranscriptViewer from './Viewer/TranscriptViewer'
import TranscriptEditor from './Viewer/TranscriptEditor'
import RecordingSearch from './Viewer/RecordingSearch'
// import WordEditor from './Viewer/WordEditor'
import Captions from './Viewer/Captions'
import Controls from './Viewer/Controls'
import Thumbnails from './Viewer/Thumbnails'
import { SplitPane, Pane } from 'react-split-pane';
import './Viewer.css';

class Viewer extends Component {
	constructor(props) {
		super(props);
		this.videoRef = React.createRef();
		this.splitPaneWidthRef = React.createRef();

		this.state = {
			lastPaneSize: ''
		};
	}

	componentDidMount() {
		window.addEventListener('hashchange', this.gotoHandler);
	}

	componentWillUnmount() {
		window.removeEventListener('hashchange', this.gotoHandler);
	}

	// Goto on change
	gotoHandler = () => {
		const urlHash = window.location.hash;
		if (urlHash.includes("#goto=")) {
			let secondsString = urlHash.substring(6);
			if(isNaN(secondsString) || Number(secondsString) % 1 !== 0 || Number(secondsString) > Math.floor(this.state.duration)) {
				console.error("URL `goto` hash parameter is not valid. It must be an integer representing seconds elapsed since the beginning of the capture.");
			} else {
				let time = Number(secondsString);
				this.triggerHandler('seek', time);
				this.triggerHandler('play');
			}
		}
	}

	triggerHandler = (event, params = {}) => {
		switch (event) {
			case 'toggleCaptions':
				this.props.updatePlayerState({ captions: !this.props.data.captions });
				break;
			default:
				this.videoRef.current.handleEvent(event, params);
		}
	}

	ondragfinishedHandler = (size) => {
		// Set width as a percentage
		// If a pixel value is used, when the browser is resized, it never recalculates size relative to the other pane
		this.setState({ lastPaneSize: (size[0]/(size[0]+size[1]))*100 + '%' });
	}

	render() {
		// TODO: REMOVE height calc? - if so calculate pane height style={{ height: paneHeight }}
		var showVideoPane = false,
			showWhiteboardPane = false,
			className = 'show-divider';

		let first = {};
		let second = {};

		if (this.props.data.visiblePresets.stage.length > 0) {
			for (var i = this.props.data.visiblePresets.stage.length - 1; i >= 0; i--) {
				if (this.props.data.visiblePresets.stage[i].visible === true) {
				showVideoPane = true;
				}
			}
		}

		if (this.props.data.visiblePresets.whiteboard.length > 0) {
			for (var j = this.props.data.visiblePresets.whiteboard.length - 1; j >= 0; j--) {
				if (this.props.data.visiblePresets.whiteboard[j].visible === true) {
				showWhiteboardPane = true;
				}
			}
		}

		if (showVideoPane === true && showWhiteboardPane === true) {
			// Both panes should be showing
			let size = undefined;
			let defaultSize = '30%';

			if (this.state.lastPaneSize !== '') {
				size = this.state.lastPaneSize;
				defaultSize = undefined;
				console.log(size);
				if (parseInt(size, 10) >= 99) {
					size = '98%';
				}
				console.log(size);
			} else {
				size = '30%';
			}

			first = {
				defaultSize: defaultSize,
				size: size
			};

			second = {
				defaultSize: undefined,
				size: undefined
			};
		} else {
			className = 'hide-divider';

			// Only one pane is showing
			if (showVideoPane === true) {
				first = {
					defaultSize: '100%',
					size: '100%'
				};

				second = {
					defaultSize: undefined,
					size: undefined
				};
			} else {
				second = {
					defaultSize: '100%',
					size: '100%'
				};

				first = {
					defaultSize: undefined,
					size: undefined
				};
			}
		}

		var overallDimensions = this.props.data.dimensions;

		var extraHeight = 	overallDimensions.extraHeaderHeight +
							overallDimensions.wordeditorHeight*this.props.data.wordeditor +
							overallDimensions.captionsHeight*this.props.data.captions +
							overallDimensions.controlsHeight*this.props.data.controls +
							overallDimensions.compactControlsHeight*(!this.props.data.controls) +
							overallDimensions.thumbnailsHeight*this.props.data.thumbnails;

		var splitPaneWidth = '100%',
			showFeatureContentPane = false;

		if (this.props.data.transcript) {
			splitPaneWidth = 'calc(100% - 450px)';
			showFeatureContentPane = true;
		}

		if (this.props.data.transcripteditor || this.props.data.search) {
			splitPaneWidth = 'calc(100% - 450px)';
			showFeatureContentPane = true;
		}

	return (
		<div className="viewer">
			<div style={{ height: 'calc(100% - ' + extraHeight + 'px)', position: 'relative' }}>
				<div style={{ width: splitPaneWidth, height: '100%' }}>
					<SplitPane
							ref={this.splitPaneWidthRef}
							onResizeEnd={this.ondragfinishedHandler}
							direction="horizontal"
							className={className}
						>
						<Pane defaultSize={first.defaultSize} size={first.size}>
							<VideoWrapper key={this.props.data.recording.info.codec_id} ref={this.videoRef} data={this.props.data} updatePlayerState={this.props.updatePlayerState} />
						</Pane>
						<Pane defaultSize={second.defaultSize} size={second.size}>
							{ showWhiteboardPane === true ? <WhiteboardWrapper data={this.props.data} updatePlayerState={this.props.updatePlayerState} /> : null }
						</Pane>
					</SplitPane>
				</div>
				<div className="feature-content-pane" style={{ display: showFeatureContentPane ? undefined : 'none' }}>
					{ this.props.data.transcript ? <TranscriptViewer data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} /> : null }
					{ this.props.data.transcripteditor ? <TranscriptEditor data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} /> : null }
					{/* Keep search mounted while hidden to retain this recording's query and results. */}
					<RecordingSearch key={this.props.data.recording.id} active={this.props.data.search} data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} />
				</div>
			</div>
			{/*<Overlay data={this.props.data} video={this.videoRef} />*/}
			{/*this.props.data.wordeditor ? <WordEditor data={this.props.data} trigger={this.triggerHandler} /> : null */}
			<Captions data={this.props.data} />
			<Controls data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} />
			{ this.props.data.supportsThumbnails ? <Thumbnails data={this.props.data} trigger={this.triggerHandler} /> : null }
	  </div>
	);
  }
}

export default Viewer;
